var $ = require('jquery');

$('.wysiwyg-content').each(function () {
    $(this).find('.eyebrow').parent().addClass('wysiwyg-parent--eyebrow');
    $(this).find('.intro-larger-text').parent().addClass('wysiwyg-parent--intro-larger-text');
    $(this).find('.button').parent().addClass('wysiwyg-parent--button');
})